export const FAILED = 'AreaManagement/failed';
export const LOADING = 'AreaManagement/loading';
export const SUCCESS = 'AreaManagement/success';
export const ACTION = 'AreaManagement/action';

export const toastMessage = {
  add: {
    success: 'Wilayah berhasil ditambahkan',
    failed: 'Wilayah gagal ditambahkan',
  },
  edit: {
    success: 'Wilayah berhasil diubah',
    failed: 'Wilayah gagal diubah',
  },
  delete: {
    success: 'Wilayah berhasil dihapus',
    failed: 'Wilayah gagal dihapus',
  },
};
